import { Component, Mixins } from 'vue-property-decorator'
import { VBtn } from 'vuetify/lib/components/VBtn'
import HsComponent from '../hs-components'

@Component
export default class extends Mixins(HsComponent, VBtn) {
  click(e) {
    VBtn.options.methods.click.call(this, e)
  }
}
